var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _ellipse2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonster0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 185,
    viewBox: "0 0 187 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.6687,
    cy: 163.5,
    rx: 82.5,
    ry: 21.5,
    fill: "url(#paint0_radial_14011_169614)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.807 127.949C107.687 132.509 105.05 149.258 103.948 155.72C103.71 157.06 104.726 158.27 106.087 158.27H115.035C117.845 158.27 117.996 154.078 115.187 153.905C114.798 153.883 114.43 153.862 114.063 153.862C112.182 153.84 111.21 151.657 112.42 150.231C119.661 141.759 124.07 130.478 125.388 126.826C125.777 125.723 125.237 124.513 124.156 124.059C122.557 123.411 119.985 123.087 117.262 123.087C111.231 123.087 104.466 124.686 105.807 127.949Z",
    fill: "url(#paint1_linear_14011_169614)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7259 124.059C60.6452 124.513 60.1049 125.723 60.4939 126.825C61.8124 130.478 66.2216 141.759 73.4622 150.231C74.6725 151.657 73.6999 153.84 71.8195 153.862C71.4521 153.862 71.0846 153.883 70.6956 153.905C67.8858 154.078 68.0371 158.271 70.8469 158.271H79.795C81.1566 158.271 82.1725 157.06 81.9347 155.72C80.8324 149.258 78.1955 132.509 80.0759 127.949C81.416 124.686 74.6509 123.086 68.6207 123.086C65.8974 123.086 63.3253 123.411 61.7259 124.059Z",
    fill: "url(#paint2_linear_14011_169614)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0957 117.97C20.0957 157.97 39.0888 151.952 41.0716 149.97C41.0716 149.97 52.0987 155.952 52.7596 145.622C52.7944 144.892 52.8292 144.265 52.864 143.709C52.7944 143.883 52.7596 143.952 52.7596 143.952C52.7596 143.952 53.3162 136.474 52.864 143.709C53.4553 142.526 55.8903 137.205 54.4293 133.97C52.7596 130.318 44.411 131.987 44.411 131.987C44.411 131.987 25.7658 93.6564 46.7417 45.343C46.7417 45.343 20.0957 78.0041 20.0957 117.97Z",
    fill: "url(#paint3_linear_14011_169614)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.286 131.987C142.286 131.987 133.937 130.318 132.268 133.97C130.807 137.205 133.242 142.526 133.833 143.709C133.381 136.474 133.937 143.952 133.937 143.952C133.937 143.952 133.903 143.883 133.833 143.709C133.868 144.265 133.903 144.892 133.937 145.622C134.598 155.952 145.625 149.97 145.625 149.97C147.608 151.952 166.601 157.97 166.601 117.97C166.601 78.0044 139.955 45.3434 139.955 45.3434C160.931 93.6566 142.286 131.987 142.286 131.987Z",
    fill: "url(#paint4_linear_14011_169614)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.738 128.584C125.008 127.887 125.228 127.294 125.397 126.826C125.786 125.724 125.245 124.513 124.165 124.059C122.565 123.411 119.993 123.087 117.27 123.087C111.24 123.087 104.475 124.686 105.815 127.949C106.252 129.008 106.445 130.724 106.47 132.816C113.411 131.868 119.471 130.428 124.738 128.584Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4153 133.601C79.3988 131.155 79.5821 129.138 80.0722 127.95C81.4122 124.686 74.6471 123.087 68.6169 123.087C65.8936 123.087 63.3216 123.411 61.7221 124.059C60.6415 124.513 60.1011 125.724 60.4902 126.826C60.7435 127.527 61.1108 128.511 61.5904 129.701C66.6746 131.598 72.5786 132.953 79.4153 133.601Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4028 25.3341C33.3443 29.9892 34.5894 36.214 39.2178 39.2993C43.8732 42.3575 58.1102 46.3901 61.1688 41.7621C64.2543 37.1341 54.9976 25.5777 50.3421 22.5195C48.6369 21.3828 46.7152 20.8415 44.7935 20.8415C41.5455 20.8415 38.3516 22.4112 36.4028 25.3341Z",
    fill: "url(#paint5_linear_14011_169614)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1706 31.9813C37.1706 27.1816 39.5077 24.3175 45.1758 24.3171C50.8439 24.3168 52.984 31.36 52.984 34.3609C52.984 38.1121 51.557 40.0885 46.5235 40.0885C41.4901 40.0885 37.1706 36.781 37.1706 31.9813Z",
    fill: "url(#paint6_linear_14011_169614)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.819 22.5195C129.163 25.5777 119.907 37.1341 122.992 41.7621C126.051 46.3901 140.288 42.3575 144.943 39.2993C149.571 36.214 150.844 29.9892 147.758 25.3341C145.809 22.4112 142.615 20.8415 139.367 20.8415C137.446 20.8415 135.524 21.3828 133.819 22.5195Z",
    fill: "url(#paint7_linear_14011_169614)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.089 31.9793C147.089 27.1797 144.752 24.3156 139.084 24.3152C133.416 24.3148 131.276 31.358 131.276 34.3589C131.276 38.1101 132.703 40.0865 137.736 40.0865C142.769 40.0865 147.089 36.779 147.089 31.9793Z",
    fill: "url(#paint8_linear_14011_169614)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7148 25.4638C46.996 28.5372 43.1847 49.3129 35.6851 66.0319C28.6772 81.8903 26.956 136.842 98.8785 131.187C170.801 125.532 160.474 72.6703 141.54 47.9607C125.189 26.8161 101.829 25.3409 95.4361 25.3409C94.3296 25.3409 93.7148 25.4638 93.7148 25.4638Z",
    fill: "url(#paint9_linear_14011_169614)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.374 70.8556C156.414 92.1227 148.423 106.383 135.637 117.447C122.851 128.387 80.9281 136.132 53.1432 118.922C31.3825 105.276 33.5955 77.9856 35.5625 66.3071C28.6778 82.534 27.4484 136.87 98.8776 131.215C164.529 126.052 161.701 81.4276 146.21 54.9974C148.054 59.3 149.899 64.5861 151.374 70.8556Z",
    fill: "url(#paint10_linear_14011_169614)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1312 126.306C62.3948 123.356 65.9497 121.201 70.7734 119.299C70.7734 119.299 70.8296 118.891 67.5004 118.891C62.8209 118.891 58.6664 121.449 56.4562 125.062C57.3191 125.494 58.2105 125.909 59.1312 126.306ZM117.656 46.9421C118.971 46.9421 120.037 45.8385 120.037 44.4771C120.037 43.1156 118.971 42.012 117.656 42.012C116.341 42.012 115.274 43.1156 115.274 44.4771C115.274 45.8385 116.341 46.9421 117.656 46.9421ZM109.145 39.9956C109.145 42.3912 107.315 44.3333 105.057 44.3333C102.799 44.3333 100.969 42.3912 100.969 39.9956C100.969 37.6 102.799 35.658 105.057 35.658C107.315 35.658 109.145 37.6 109.145 39.9956ZM109.988 53.614C110.768 53.614 111.401 52.9584 111.401 52.1497C111.401 51.3409 110.768 50.6853 109.988 50.6853C109.207 50.6853 108.574 51.3409 108.574 52.1497C108.574 52.9584 109.207 53.614 109.988 53.614ZM96.4013 49.4043C96.4013 50.7234 95.3682 51.7927 94.0937 51.7927C92.8193 51.7927 91.7861 50.7234 91.7861 49.4043C91.7861 48.0852 92.8193 47.0159 94.0937 47.0159C95.3682 47.0159 96.4013 48.0852 96.4013 49.4043ZM99.5771 60.4773C101.098 60.4773 102.331 59.2009 102.331 57.6265C102.331 56.052 101.098 54.7756 99.5771 54.7756C98.0562 54.7756 96.8232 56.052 96.8232 57.6265C96.8232 59.2009 98.0562 60.4773 99.5771 60.4773ZM97.6972 70.7727C97.6972 71.5809 97.0644 72.2361 96.2837 72.2361C95.503 72.2361 94.8701 71.5809 94.8701 70.7727C94.8701 69.9645 95.503 69.3093 96.2837 69.3093C97.0644 69.3093 97.6972 69.9645 97.6972 70.7727ZM85.3291 69.4285C88.4119 69.4285 90.9111 66.8418 90.9111 63.6509C90.9111 60.46 88.4119 57.8733 85.3291 57.8733C82.2462 57.8733 79.747 60.46 79.747 63.6509C79.747 66.8418 82.2462 69.4285 85.3291 69.4285ZM89.4463 81.1814C89.4463 83.2239 87.8471 84.8796 85.8745 84.8796C83.9019 84.8796 82.3027 83.2239 82.3027 81.1814C82.3027 79.1389 83.9019 77.4832 85.8745 77.4832C87.8471 77.4832 89.4463 79.1389 89.4463 81.1814ZM69.4419 67.2981C70.5111 67.2981 71.3779 66.4015 71.3779 65.2954C71.3779 64.1894 70.5111 63.2927 69.4419 63.2927C68.3726 63.2927 67.5058 64.1894 67.5058 65.2954C67.5058 66.4015 68.3726 67.2981 69.4419 67.2981ZM83.4746 50.5042C83.4746 51.9504 82.3415 53.1228 80.9438 53.1228C79.5461 53.1228 78.4131 51.9504 78.4131 50.5042C78.4131 49.0579 79.5461 47.8855 80.9438 47.8855C82.3415 47.8855 83.4746 49.0579 83.4746 50.5042Z",
    fill: "url(#paint11_linear_14011_169614)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5305 87.0141C44.5305 87.0141 33.7837 103.795 62.4929 118.125C90.8182 132.3 112.887 124.101 125.783 117.512C132.347 114.178 139.677 105.903 141.289 98.5847C143.976 86.1712 133.114 78.8916 122.214 84.4854C112.964 89.2362 108.918 90.2071 96.1372 89.7091C74.2599 88.8662 70.0539 84.7919 59.0002 82.3015C57.3882 81.9184 55.9297 81.7651 54.5863 81.7651C47.0252 81.7651 44.5305 87.0141 44.5305 87.0141Z",
    fill: "url(#paint12_radial_14011_169614)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14011_169614",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 81,
    width: 100,
    height: 45
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5305 87.0141C44.5305 87.0141 33.7837 103.795 62.4929 118.125C90.8182 132.3 112.887 124.101 125.783 117.512C132.347 114.178 139.677 105.903 141.289 98.5847C143.976 86.1712 133.114 78.8916 122.214 84.4854C112.964 89.2362 108.918 90.2071 96.1372 89.7091C74.2599 88.8662 70.0539 84.7919 59.0002 82.3015C57.3882 81.9184 55.9297 81.7651 54.5863 81.7651C47.0252 81.7651 44.5305 87.0141 44.5305 87.0141Z",
    fill: "url(#paint13_radial_14011_169614)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14011_169614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3865 89.0018C93.8887 91.428 94.9217 93.6939 96.3687 95.476C98.9915 98.7038 103.132 100.977 106.552 98.3095C108.918 96.4653 110.122 92.9401 109.847 89.5925C109.767 88.6104 109.636 87.6096 109.43 86.6521C106.436 88.531 102.969 89.7268 98.3799 89.5087C96.6008 89.4235 94.9478 89.2444 93.3865 89.0018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.08 80.5393C126.08 80.5393 123.844 83.499 123.025 82.067C122.555 82.4443 120.135 82.8208 119.664 83.289C115.045 87.8738 112.331 87.5693 112.331 87.5693C113.728 91.1062 115.68 93.827 117.871 95.2159C121.387 97.448 127.914 96.4272 128.525 90.622C128.525 84.2057 127.572 84.9877 126.08 80.5393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4437 86.0398C74.019 86.5262 73.4429 87.414 73.0861 88.138C71.9994 91.2339 71.5717 95.3365 73.4429 98.2395C75.0548 100.74 79.9165 101.899 83.3043 99.7889C87.8605 96.0934 87.7449 90.7842 88.8039 88.1785C84.832 88.1785 83.47 88.1596 80.5122 87.4338C80.5122 87.4338 77.1935 86.6509 74.4437 86.0398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2776 93.0669C61.5147 95.345 58.2502 95.4574 55.7697 92.0754C53.8357 89.4395 53.858 85.6549 55.4012 82.9003C55.8002 82.1871 56.2436 81.6114 56.7292 81.1506C57.6733 81.2314 59.6052 81.5411 60.6945 81.81C64.9604 82.8616 70.7772 85.1069 70.7772 85.1069C69.6716 87.3401 68.2365 90.4564 65.2776 93.0669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9703 85.774C61.5286 81.6957 68.7646 86.1099 69.5555 87.5664C69.9931 87.0177 70.141 86.3521 70.4722 85.7332C66.8217 83.1723 63.4311 83.2096 59.1652 82.235C58.076 81.9859 57.0627 81.8361 56.1174 81.7612C55.633 82.1882 55.1896 82.7217 54.7906 83.3827C53.2474 85.9355 53.3621 89.7052 55.1591 91.8856C56.4175 93.0661 55.8064 92.455 57.3341 93.6772C56.1119 91.8439 53.5597 88.8251 56.9703 85.774Z",
    fill: "#F5C5A9"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8373 113.763C88.7498 114.307 87.6019 114.911 86.4136 114.729C85.8497 114.649 85.3261 114.387 84.8226 114.166C81.2378 112.555 77.2099 111.608 73.4035 112.514C69.7986 113.34 66.5158 116.099 65.7304 119.663C89.0519 130.115 107.882 125.543 120.55 119.985C118.133 115.696 113.703 112.474 108.869 111.205C106.976 110.702 105.043 110.48 103.089 110.48C98.5376 110.48 93.9458 111.729 89.8373 113.763Z",
    fill: "url(#paint14_radial_14011_169614)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.557 119.989C119.268 117.709 117.413 115.746 115.24 114.204C115.242 114.54 115.213 114.875 115.118 115.197C114.443 117.486 112.195 118.927 109.988 119.832C107.276 120.944 104.367 121.566 101.438 121.66C100.801 121.68 100.146 121.671 99.5524 121.437C97.864 120.771 97.3773 118.675 96.9491 116.912C96.5209 115.149 95.4842 113.089 93.6707 113.1C94.0908 112.65 94.5096 112.199 94.9308 111.748C93.1805 112.281 91.4723 112.959 89.8413 113.764C88.7614 114.298 87.6124 114.901 86.419 114.728C86.4167 114.728 86.4132 114.726 86.4108 114.726L90.4286 117.749C91.1786 118.314 91.9543 118.908 92.3744 119.748C92.7944 120.588 92.7336 121.746 91.9847 122.313C91.4243 122.736 90.6556 122.722 89.9548 122.676C83.8509 122.272 77.8206 120.78 72.2315 118.292C71.6828 118.047 71.1235 117.783 70.7105 117.345C69.7815 116.36 69.8892 114.679 70.7339 113.621C70.8065 113.53 70.9036 113.468 70.9831 113.386C68.4232 114.666 66.3417 116.919 65.7298 119.655C89.0492 130.105 107.882 125.544 120.557 119.989Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4515 116.777C92.6718 117.953 93.368 119.363 93.6722 120.405C93.829 120.928 93.912 121.36 93.9425 121.663C93.9706 121.961 93.9869 122.13 93.9869 122.13C93.9869 122.13 93.5961 121.575 92.9573 120.776C92.3173 119.972 91.3989 118.968 90.3341 117.94C89.2636 116.916 88.2234 116.039 87.3939 115.433C86.5714 114.826 86.0016 114.457 86.0016 114.457C86.0016 114.457 86.1701 114.467 86.4696 114.483C86.775 114.502 87.209 114.567 87.7379 114.703C88.7921 114.966 90.2265 115.605 91.4515 116.777Z",
    fill: "#831434"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.6935,
    cy: 68.3318,
    rx: 52.2467,
    ry: 39.7197,
    fill: "url(#paint15_linear_14011_169614)",
    fillOpacity: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.721 56.7065C111.721 66.831 103.513 75.0386 93.3888 75.0386C83.2642 75.0386 75.0566 66.831 75.0566 56.7065C75.0566 46.5819 83.2642 38.3743 93.3888 38.3743C103.513 38.3743 111.721 46.5819 111.721 56.7065Z",
    fill: "#89C072"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.888 56.7058C109.888 65.8171 102.501 73.2033 93.3891 73.2033C84.277 73.2033 76.8902 65.8171 76.8902 56.7058C76.8902 47.5944 84.277 40.2083 93.3891 40.2083C102.501 40.2083 109.888 47.5944 109.888 56.7058Z",
    fill: "url(#paint16_radial_14011_169614)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.974 56.4027C101.974 61.3043 98.0001 65.2779 93.0981 65.2779C88.1961 65.2779 84.2222 61.3043 84.2222 56.4027C84.2222 51.5011 88.1961 47.5276 93.0981 47.5276C98.0001 47.5276 101.974 51.5011 101.974 56.4027Z",
    fill: "url(#paint17_radial_14011_169614)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2489 56.4021C97.2489 58.6941 95.3901 60.5527 93.0988 60.5527C90.8031 60.5527 88.9443 58.6941 88.9443 56.4021C88.9443 54.1101 90.8031 52.2506 93.0988 52.2506C95.3901 52.2506 97.2489 54.1101 97.2489 56.4021Z",
    fill: "#2E2A49"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.387 65.2615C137.387 72.0112 131.915 77.483 125.165 77.483C118.416 77.483 112.944 72.0112 112.944 65.2615C112.944 58.5118 118.416 53.04 125.165 53.04C131.915 53.04 137.387 58.5118 137.387 65.2615Z",
    fill: "#89C072"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.166 65.2591C136.166 71.3333 131.241 76.2574 125.167 76.2574C119.092 76.2574 114.167 71.3333 114.167 65.2591C114.167 59.1849 119.092 54.2607 125.167 54.2607C131.241 54.2607 136.166 59.1849 136.166 65.2591Z",
    fill: "url(#paint18_radial_14011_169614)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.5 65.0686C131.5 68.3364 128.851 70.9854 125.583 70.9854C122.315 70.9854 119.666 68.3364 119.666 65.0686C119.666 61.8009 122.315 59.1519 125.583 59.1519C128.851 59.1519 131.5 61.8009 131.5 65.0686Z",
    fill: "url(#paint19_radial_14011_169614)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.349 65.0696C128.349 66.5976 127.11 67.8367 125.583 67.8367C124.052 67.8367 122.813 66.5976 122.813 65.0696C122.813 63.5416 124.052 62.3019 125.583 62.3019C127.11 62.3019 128.349 63.5416 128.349 65.0696Z",
    fill: "#2E2A49"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8348 65.2488C73.8348 71.9985 68.3631 77.4703 61.6134 77.4703C54.8636 77.4703 49.3919 71.9985 49.3919 65.2488C49.3919 58.4991 54.8636 53.0273 61.6134 53.0273C68.3631 53.0273 73.8348 58.4991 73.8348 65.2488Z",
    fill: "#89C072"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6139 65.2491C72.6139 71.3233 67.6893 76.2474 61.6146 76.2474C55.5398 76.2474 50.6153 71.3233 50.6153 65.2491C50.6153 59.1749 55.5398 54.2507 61.6146 54.2507C67.6893 54.2507 72.6139 59.1749 72.6139 65.2491Z",
    fill: "url(#paint20_radial_14011_169614)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3356 65.054C67.3356 68.3217 64.6863 70.9707 61.4183 70.9707C58.1503 70.9707 55.501 68.3217 55.501 65.054C55.501 61.7862 58.1503 59.1372 61.4183 59.1372C64.6863 59.1372 67.3356 61.7862 67.3356 65.054Z",
    fill: "url(#paint21_radial_14011_169614)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1891 65.0576C64.1891 66.5856 62.9499 67.8247 61.4223 67.8247C59.8919 67.8247 58.6527 66.5856 58.6527 65.0576C58.6527 63.5296 59.8919 62.29 61.4223 62.29C62.9499 62.29 64.1891 63.5296 64.1891 65.0576Z",
    fill: "#2E2A49"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.6687 163.5) rotate(90) scale(21.5 82.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14011_169614",
    x1: 103.905,
    y1: 123.088,
    x2: 125.518,
    y2: 123.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14011_169614",
    x1: 60.3643,
    y1: 123.088,
    x2: 81.9779,
    y2: 123.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14011_169614",
    x1: 20.0957,
    y1: 45.3589,
    x2: 54.8815,
    y2: 45.3589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14011_169614",
    x1: 131.815,
    y1: 45.3592,
    x2: 166.601,
    y2: 45.3592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14011_169614",
    x1: 34.7247,
    y1: 18.823,
    x2: 61.7913,
    y2: 18.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14011_169614",
    x1: 52.984,
    y1: 32.4831,
    x2: 37.1702,
    y2: 32.4831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14011_169614",
    x1: 149.436,
    y1: 18.8241,
    x2: 122.37,
    y2: 18.8241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_169614",
    x1: 131.276,
    y1: 32.4811,
    x2: 147.089,
    y2: 32.4811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_169614",
    x1: 32.4885,
    y1: 17.0241,
    x2: 155.433,
    y2: 17.0241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14011_169614",
    x1: 32.489,
    y1: 31.8366,
    x2: 155.431,
    y2: 31.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14011_169614",
    x1: 56.4562,
    y1: 102.967,
    x2: 120.037,
    y2: 102.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CA64B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.1231 103.846) scale(38.3812 17.0981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.1231 103.846) scale(38.3812 17.0981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.1402 118.201) scale(20.1395 7.39812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14011_169614",
    x1: 93.6935,
    y1: 28.6121,
    x2: 93.388,
    y2: 82.0703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.3894 56.7056) scale(16.499 16.4975)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.0976 56.4032) scale(8.87592 8.87514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.167 65.2589) scale(10.9993 10.9984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.583 65.0689) scale(5.91728 5.91676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.6147 65.2489) scale(10.9993 10.9984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_14011_169614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.418 65.0543) scale(5.91728 5.91676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonster0);
export default __webpack_public_path__ + "static/media/Monster0.4ec690a796b9186c0604ca1e3fa48293.svg";
export { ForwardRef as ReactComponent };